import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const expectedState = window.localStorage.getItem("kf_google_oauth_state");
    if (!code) {
      navigate("/login", { replace: true });
      return;
    }
    if (!state || !expectedState || state !== expectedState) {
      window.localStorage.removeItem("kf_google_oauth_state");
      toast.error("Google sign-in state mismatch");
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/callback",
          { code, state }
        );
        window.localStorage.removeItem("kf_google_oauth_state");
        login(data.token, data.user);
        toast.success(`Welcome, ${data.user.firstname || data.user.name}!`);
        // Clear callback query and go to dashboard
        window.history.replaceState(null, "", "/camper");
        navigate("/camper", { replace: true });
      } catch (e) {
        window.localStorage.removeItem("kf_google_oauth_state");
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#FFF4E6]">
      <div className="text-center">
        <div className="display text-3xl text-[#3D1E6D]">Signing you in…</div>
        <div className="text-sm text-[#6B4E9E] mt-2">via Google</div>
      </div>
    </div>
  );
}
